/**
 * Footer link lists: native <details> (sections/footer.liquid). Collapsed on phones; on tablet and desktop every list
 * is open and its title is not a control. CSS shows the lists there from first paint; this keeps the open state and
 * the title's tab stop in step for assistive technology. Nested lists open from their arrow buttons.
 * Wrapped so the theme editor can run this file again when it reloads the footer section.
 */
(() => {
  const wide = window.matchMedia('(min-width: 768px)');

  const syncMenus = () => {
    document.querySelectorAll('.footer details.widget--menu').forEach((details) => {
      details.open = wide.matches;
      details.querySelector('summary')?.setAttribute('tabindex', wide.matches ? '-1' : '0');
    });
  };

  if (!window.footerMenusBound) {
    window.footerMenusBound = true;
    wide.addEventListener('change', syncMenus);
    document.addEventListener('shopify:section:load', syncMenus);

    document.addEventListener('click', (event) => {
      // Wide screens keep every list open: the title does not toggle there.
      if (wide.matches && event.target.closest('.footer details.widget--menu > summary')) {
        event.preventDefault();
        return;
      }
      const arrow = event.target.closest('.footer .thb-arrow');
      if (!arrow) return;
      event.preventDefault();
      const submenu = arrow.parentNode.querySelector(':scope > .sub-menu');
      if (!submenu) return;
      const open = submenu.classList.toggle('active');
      arrow.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  syncMenus();
})();
